import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { catchError } from 'rxjs/operators';
import { EMPTY, Observable, throwError } from 'rxjs';

import { Logout } from '../actions';
import { CreateCustomTokenResponse, User, CreateUser, UserResponse } from '../models';
import { SnackbarService } from '@fitscovery/ui/snackbar';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from '../environment-injection';

@Injectable()
export class ApiAuthService {

  constructor(
    private store: Store,
    private http: HttpClient,
    @Inject(APP_ENVIRONMENT) private env: Environment,
    private snackbar: SnackbarService
  ) { }

  updateUser(user: User): Observable<UserResponse> {
    return <Observable<UserResponse>>this.http.put(`${this.env.azureFunctionsApi.auth}/auth/account`, user);
  }

  signUp(user: CreateUser): Observable<any> {
    return this.http.post(`${this.env.azureFunctionsApi.auth}/auth/sign-up`, user).pipe(
      catchError((response: HttpErrorResponse) => this.displayErrorMessage(response, this.snackbar))
    );
  }

  signOutRevokeUserToken(): Observable<null> {
    return <Observable<null>>this.http.post(`${this.env.azureFunctionsApi.auth}/auth/sign-out`, {}).pipe(
      catchError(() => this.store.dispatch(new Logout))
    );
  }

	createCustomToken(): Observable<CreateCustomTokenResponse> {
		return this.http.post<CreateCustomTokenResponse>(`${this.env.azureFunctionsApi.auth}/auth/token`, null);
	}

	createCustomTokenManual(token: string): Observable<CreateCustomTokenResponse> {
		return this.http.post<CreateCustomTokenResponse>(`${this.env.azureFunctionsApi.auth}/auth/token`, null, {
      headers: { Authorization: token }
    });
	}

  confirmEmailVerification(verificationCode: string): Observable<any> {
    const body = { verificationCode };
		return this.http.post(`${this.env.azureFunctionsApi.auth}/auth/account/confirm-email-verification`, body).pipe(
      catchError((response: HttpErrorResponse) => {
        // this.displayErrorMessage(response, this.snackbar);
        return throwError(response);
      })
    );
	}
    
  sendEmailVerification() : Observable<any> {
    return <Observable<any>>this.http.post(`${this.env.azureFunctionsApi.auth}/auth/account/send-email-verification`, null);
	}

  private displayErrorMessage(response: HttpErrorResponse, snackbar: SnackbarService) {
    if (response.status === 400) {
      const message = response.error.errors[0];
      snackbar.openSnack({ message, duration: 7000 });
    }
    return EMPTY;
  }

}
